import { memo, useMemo } from "react";
import { AppLabel } from "../../../../../shared/components/AppLabel";
import { AppNewInput } from "../../../../../shared/components/AppNewInput";
import { TSkillField } from "../../../types";
import styles from "./styles.module.css";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props {
  skill: TSkillField | null;
  error: boolean;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    id: string,
  ) => void;
  onBlur: (id: string) => void;
  handleBeforeInput: (
    e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement> | any,
    id: string,
  ) => void;
  handlePaste: (e: React.ClipboardEvent, id: string) => void;
}

const SkillFieldInner = ({
  skill,
  error,
  onChange,
  handleBeforeInput,
  handlePaste,
  onBlur,
}: Props) => {
  const { t } = useTranslation();
  const nameLabel = useMemo(() => {
    return skill?.label === t("skills.name_label") ? "name" : "";
  }, [skill]);

  if (!skill) return;

  return (
    <div className={styles[`input-${skill.label.toLowerCase()}-container`]}>
      <AppLabel className={styles["field-label"]}>{skill.label}</AppLabel>
      <AppNewInput
        value={skill.value}
        onChange={(e) => onChange(e, skill.id)}
        onBlur={() => onBlur(skill.id)}
        onBeforeInput={(e) => handleBeforeInput(e, skill.id)}
        onPaste={(e) => handlePaste(e, skill.id)}
        multiline
        placeholder={skill.placeholder}
        minRows={skill.rows}
        className={classNames(
          styles[`input-${skill.label.toLowerCase()}`],
          error && styles[`error-input-${nameLabel}`],
        )}
      />
    </div>
  );
};

export const SkillField = memo(SkillFieldInner);
